module.exports = __webpack_public_path__ + "static/img/walkway-crossing_256.8fdb2ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/walkway-crossing_256.png
// module id = 3MF8
// module chunks = 0